/** Head-of-family dashboard (/family). Off for the pilot: every QR has exactly one owner. */
export const FAMILY_DASHBOARD_ENABLED = process.env.REACT_APP_FAMILY_DASHBOARD === "true";
